const getters = {
  deployUploadApi: state => state.api.deployUploadApi,
  databaseUploadApi: state => state.api.databaseUploadApi,
  size: state => state.app.size,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  roles: state => state.user.roles,
  user: state => state.user.user,
  pwdExpired: state => state.user.pwdExpired,
  pwdExpiredPending: state => state.user.pwdExpiredPending,
  appCode: state => state.user.appCode,
  verifyInfo: state => state.user.verifyInfo,
  wxAppInfo: state => state.user.wxAppInfo,
  memberInfo: state => state.user.memberInfo,
  userType: state => state.user.user.userType,
  loadMenus: state => state.user.loadMenus,
  permission_routers: state => state.permission.routers,
  permission: state => state.user.permission,
  routerMenuOptions: state => state.permission.routerMenuOptions,
  addRouters: state => state.permission.addRouters,
  socketApi: state => state.api.socketApi,
  imagesUploadApi: state => state.api.imagesUploadApi,
  baseApi: state => state.api.baseApi,
  fileUploadApi: state => state.api.fileUploadApi,
  taxRecodesUploadApi: state => state.api.taxRecodesUploadApi,
  updateAvatarApi: state => state.api.updateAvatarApi,
  qiNiuUploadApi: state => state.api.qiNiuUploadApi,
  sqlApi: state => state.api.sqlApi,
  swaggerApi: state => state.api.swaggerApi,
  platformInfo: state => state.user.platformInfo,
	entBusinessInfo: state => state.user.entBusinessInfo,
  interest: state => state.user.interest,
}
export default getters
